import { useCallback, useEffect, useMemo, useState } from 'react';
import { getCenterstageScreenshotFallbackUrls } from './videoSources';

export function useImageSourceWithFallback(src?: string): {
  resolvedSrc?: string;
  handleError: () => void;
} {
  const fallbackUrls = useMemo(
    () => getCenterstageScreenshotFallbackUrls(src),
    [src]
  );
  const [fallbackIndex, setFallbackIndex] = useState(0);

  useEffect(() => {
    setFallbackIndex(0);
  }, [src]);

  const handleError = useCallback(() => {
    setFallbackIndex((currentIndex) =>
      currentIndex < fallbackUrls.length ? currentIndex + 1 : currentIndex
    );
  }, [fallbackUrls.length]);

  return {
    resolvedSrc: fallbackUrls[fallbackIndex],
    handleError,
  };
}
